import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import useBrowserMode from '../../../hooks/useBrowserMode'
import './layout-modal.scss'

const LayoutModal = props => {
  const { noScroll = false, onClose = () => {} } = props

  const { isBrowser } = useBrowserMode()
  const ModalPortal = isBrowser && document?.querySelector('#modal-portal')

  useEffect(() => {
    noScroll && document.body.classList.add('overflow-body-hidden')

    return () => {
      noScroll && document.body.classList.remove('overflow-body-hidden')
    }
  }, [])

  return ModalPortal
    ? createPortal(
        <section className="f-modal-container">
          <div className="f-modal-facade" onClick={onClose} />
          {props.children}
        </section>,
        ModalPortal
      )
    : null
}

export default LayoutModal
